import React from 'react';
import { Props } from './types';
import { TrackerCircle } from './styles';

const Circle: React.FC<Props> = ({ variant }) => <TrackerCircle variant={variant} />;

export default Circle;
